import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { defineStyles } from '../../theme';
import { useSTColumns, useSTRows } from '../SmartTableContext';
import { cellStyle } from '../styles';
import { TableHeaderCell } from './TableHeaderCell';
import TableSelectionCell from './TableSelectionCell';
const styles = defineStyles({
    headerRow: {
        '& th:last-of-type': { borderRight: 'unset' },
    },
    countCell: {
        ...cellStyle,
        textAlign: 'center',
    },
});
export function TableHeader() {
    const { visibleColumns } = useSTColumns();
    const { rowsSelectEnabled } = useSTRows();
    return (_jsx(TableHead, { children: _jsxs(TableRow, { sx: styles.headerRow, children: [rowsSelectEnabled && _jsx(TableSelectionCell, {}), visibleColumns.map((cell, columnIndex) => (_jsx(TableHeaderCell, { cell: cell, columnIndex: columnIndex }, `table-cell-${cell.fieldName}`)))] }) }));
}
//# sourceMappingURL=TableHeader.js.map